import { FeatureFlag } from '../FeatureFlag';

export const useAlphaEyeVolumeProfileTab = new FeatureFlag({
    key: 'use-alpha-eye-volume-profile-tab',
    defaultValue: false,
});
